import "core-js/modules/es.string.small";

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import classNames from "classnames";
import React from "react";
import BranchLink from "web/react/components/branch-link/branch-link";
import { gettext } from "web/script/modules/django-i18n";
import { DesktopCampaignRawBranchLink, RawBranchLink } from "web/script/utils/branch-io";
import styles from "./app-download-badge.css";
var APP_DOWNLOAD_LINKS = {
  footer: RawBranchLink.Footer,
  appPage: RawBranchLink.AppPage,
  appTeaser: RawBranchLink.AppTeaser,
  desktopAppBannerFeeds: DesktopCampaignRawBranchLink.Feed
};
export function AppDownloadBadge(_ref) {
  var _classNames;

  var color = _ref.color,
      small = _ref.small,
      appDownloadLink = _ref.appDownloadLink,
      eventLabel = _ref.eventLabel,
      titleId = _ref.titleId;
  var title = "";

  if (titleId) {
    title = gettext(titleId);
  }

  var branchLink = APP_DOWNLOAD_LINKS[appDownloadLink];
  return React.createElement(BranchLink, {
    className: classNames(styles.badge, (_classNames = {}, _defineProperty(_classNames, styles.black, color == "black"), _defineProperty(_classNames, styles.white, color == "white"), _defineProperty(_classNames, styles.small, small), _classNames)),
    branchLink: branchLink,
    eventLabel: eventLabel,
    title: title
  });
}
export default AppDownloadBadge;